export default {
      id: "social-02-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "assets/img/svg/sprite.svg#social-02",
      toString: function () {
        return this.url;
      }
    }